import { styled } from '@mui/material/styles';

export const FileAvatar = styled('div')<{ $bgColor: string }>`
  width: 100%;
  height: 256px;
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
  background-color: ${({ $bgColor }) => $bgColor};
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 48px;
  font-weight: 500;
`;

export const SmallButton = styled('a')`
  :hover {
    background-color: ${({ theme }) => theme.palette.grey['02']};
  }
  padding: 12px 12px;
  border-radius: 8px;
  cursor: pointer;
  text-decoration: none;
`;
